import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { "color-white": "" }, "数据加载中...", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  id: "map-chart",
  class: "map",
  style: {"width":"960px","height":"600px"}
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dv_loading = _resolveComponent("dv-loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.showloading)
      ? (_openBlock(), _createBlock(_component_dv_loading, { key: 0 }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _hoisted_2
  ], 64))
}